import { render, staticRenderFns } from "./twitter-compare.vue?vue&type=template&id=f162d004&scoped=true&"
import script from "./twitter-compare.vue?vue&type=script&lang=js&"
export * from "./twitter-compare.vue?vue&type=script&lang=js&"
import style0 from "./twitter-compare.vue?vue&type=style&index=0&id=f162d004&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f162d004",
  null
  
)

export default component.exports